import { Tag, Popconfirm } from '@douyinfe/semi-ui';
import cls from 'classnames';
import { Post } from '@/typings/open.platform.forum_bff/namespaces/forumpost';
import { useTopAndGood } from '@/hooks/useTop';
import useBiz from '@/context/useBiz';
import usePost from '@/context/usePost';

type Props = {
  post: Post;
  isAdmin?: boolean;
};

type ColorType = 'top' | 'good';

export const PostTags = ({ post, isAdmin = false }: Props) => {
  const { toggleGood, toggleTop } = useTopAndGood();
  const biz = useBiz(state => state.biz);
  const refetchPost = () => usePost.setState({ shouldRefetch: true });

  if (isAdmin) {
    return (
      <>
        {
          <Popconfirm
            title={post.IsTop ? '确定取消置顶么' : '确定置顶么'}
            onConfirm={async () => {
              await toggleTop(post.Id, biz);
              refetchPost?.();
            }}>
            <span>
              <MyTag color="top" shouldActive={post.IsTop}>
                {' '}
                置顶{' '}
              </MyTag>
            </span>
          </Popconfirm>
        }
        {
          <Popconfirm
            title={post.IsGood ? '确定取消加精么' : '确定加精么'}
            onConfirm={async () => {
              await toggleGood(post.Id, biz);
              refetchPost?.();
            }}>
            <span>
              <MyTag color="good" shouldActive={post.IsGood}>
                {' '}
                精
              </MyTag>
            </span>
          </Popconfirm>
        }
      </>
    );
  }

  return (
    <>
      {post.IsTop && <MyTag color="top"> 置顶 </MyTag>}
      {post.IsGood && <MyTag color="good"> 精</MyTag>}
    </>
  );
};

type MyTagProps = {
  shouldActive?: boolean;
  color: ColorType;
  children: React.ReactNode;
};
const MyTag = ({
  shouldActive = true,
  color,
  children,
  ...reset
}: MyTagProps) => (
  <Tag
    {...reset}
    className={cls('hover:cursor-pointer hover:opacity-100')}
    // color={color === 'good' ? 'orange' : 'red'}
    style={{
      opacity: shouldActive ? 1 : 0.3,
      color: color === 'good' ? '#FC8800' : '#F93920',
      background:
        color === 'good'
          ? 'rgba(252, 136, 0, 0.15)'
          : 'rgba(249, 57, 32, 0.15)',
    }}>
    {children}
  </Tag>
);

// const ClickableTag = styled(Tag)`
//   cursor: pointer;
//   font-size: 12px;
//   opacity: ${({ active }) => (active ? 1 : 0.3)};
//   display: inline-block;
//   transition: 0.3s;
//   &:hover {
//     opacity: 1;
//   }
// `;
